export default function access(initialState: { currentUser?: any }) {
  const { currentUser } = initialState || {};

  // user_type: 1=超管, 2=OEM, 3=代理, 4=普通用户, 5=运营
  const userType = currentUser?.user_type;

  return {
    // 普通用户权限 - 所有登录用户都有（工作台入口）
    canUser: !!userType,
    // 仅普通用户权限 - 用于基础管理、素材管理、成品库、发布管理等页面
    canUserOnly: userType === 4,
    // 非运营：财务、数据报表等（超管/OEM/代理/终端用户可见，运营不可见）
    canNotOps: !!userType && userType !== 5,
    // 代理权限 - 代理、OEM、超管（不含运营）
    canAgent: userType === 1 || userType === 2 || userType === 3,
    // 运营或代理侧用户管理（运营仅此菜单 + 工作台）
    canAgentOrOps: userType === 1 || userType === 2 || userType === 3 || userType === 5,
    // 仅运营
    canOps: userType === 5,
    // OEM权限 - OEM、超管
    canOem: userType === 1 || userType === 2,
    // 超管权限 - 仅超管
    canAdmin: userType === 1,
    // 仅OEM用户权限 - 用于OEM管理页面
    canOemOnly: userType === 2,
  };
}
